import React, { useEffect, useState } from "react";
import InputNumbers from "../../../Common/Helpers/InputNumbers";
import Sliders from "../../../Common/Slider/Sliders";
import areObjectsEqual from "../../../../utils/areObjectsEqual";
import { useWallet } from "../../../../context/WalletContextProvider";

/**
 * Form Component
 * Form for managing Distro Presets
 */
const Form = ({
  formData,
  handleSubmit,
  distroPresetCount,
  onDiscard,
  campaignDetails,
}) => {
  const { apiConstants } = useWallet();
  
  const [form, setForm] = useState(formData);
  const [errors, setErrors] = useState({ preset_name: false, preset_order: false });
  const [slider, setSlider] = useState([]);
  /**
   * Initialize form and slider values
   */
  useEffect(() => {
    const artistDistro =
      formData.artist_distro > campaignDetails.artist_distro_min
        ? formData.artist_distro
        : campaignDetails.artist_distro_min;

    setSlider([
      formData.beneficiary_distro,
      formData.sponsor_distro,
      artistDistro,
    ]);
    setForm(formData);
  }, [formData, campaignDetails]);

  const hasUnsavedChanges = areObjectsEqual(formData, form);

  /**
   * Handle slider changes
   */
  const handleSliderChange = (newSlider) => {
    setForm((prev) => ({
      ...prev,
      beneficiary_distro: newSlider[0],
      sponsor_distro: newSlider[1],
      artist_distro: newSlider[2],
      seller_distro: newSlider[3] || 0,
    }));
  };

  /**
   * Handle input field changes
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  /**
   * Restrict input to numbers only
   */
  const keyPressOnlyNumbers = (e) => {
    InputNumbers(e, "numbers");
  };

  /**
   * Validate form
   */
  const validateForm = () => {
    const newErrors = {
      preset_order: !form.preset_order || form.preset_order === 0,
      preset_name: !form.preset_name,
    };
    setErrors(newErrors);
    return !newErrors.preset_order && !newErrors.preset_name;
  };

  /**
   * Handle form submission
   */
  const handleClick = () => {
    if (validateForm()) {
      handleSubmit(form);
    }
  };

  return (
    <>
      <div className="mt-4">
        <label htmlFor="preset_order" className="form-labels">
          Preset order:
        </label>
        <input
          type="number"
          name="preset_order"
          id="preset_order"
          onChange={handleChange}
          value={form.preset_order}
          min={1}
          step={1}
          className="form-control mt-2 inputs"
          onKeyPress={keyPressOnlyNumbers}
          disabled
        />
        {errors.preset_order && (
          <span className="form-text text-danger">
            Minimum required preset order is 1
          </span>
        )}
      </div>

      <div className="mt-4">
        <label htmlFor="preset_name" className="text-gray form-labels">
          Preset Name:
        </label>
        <input
          type="text"
          name="preset_name"
          id="preset_name"
          onChange={handleChange}
          value={form.preset_name}
          className="form-control mt-2 inputs"
          maxLength={25}
        />
        {errors.preset_name && (
          <span className="form-text text-danger">
            Preset name is required
          </span>
        )}
      </div>

      <div className="form-title text-center mt-5 mb-4 form-labels">
        Distro Preset Percentage
      </div>

      <div className="row g-0">
        <div className="mt-10">
          <div className="slider-box">
            <Sliders
              sliders={[
                {
                  name: "Beneficiary",
                  color: "red",
                  defaultValue: formData.beneficiary_distro,
                  min: 1,
                  max: 100,
                  category: "beneficiary",
                },
                {
                  name: "Sponsor",
                  color: "red",
                  defaultValue: formData.sponsor_distro,
                  min: apiConstants.reddevcut,
                  max: 100,
                  category: "sponsor",
                },
                {
                  name: "Artist",
                  color: "red",
                  defaultValue:
                    formData.artist_distro > campaignDetails.artist_distro_min
                      ? formData.artist_distro
                      : campaignDetails.artist_distro_min,
                  min: campaignDetails.artist_distro_min,
                  max: 100,
                  category: "artist",
                },
              ]}
              slider={slider}
              handleChange={handleSliderChange}
              reddevcut={apiConstants.reddevcut}
            />
          </div>
        </div>
        <div>
          <p className="user-note">
            Note: The total is {100 - apiConstants.reddevcut * 2}% because Fund Raisin automatically collects a {apiConstants.reddevcut}% fee from the Sponsor and a fixed {apiConstants.reddevcut}% from the Artist.
          </p>
        </div>
      </div>

      <div className="pt-5">
        <button
          type="button"
          className="btn btn-secondary me-4 form-btn"
          onClick={onDiscard}
        >
          Discard
        </button>
        <button
          type="button"
          className="btn bg-orange form-btn"
          onClick={handleClick}
          disabled={hasUnsavedChanges}
        >
          Save Changes
        </button>
      </div>
    </>
  );
};

export default Form;
